import React from 'react';
import PropTypes from 'prop-types';
import PlayerMatchup from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup';
import { PlayerMatchupTypes } from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup.types';
import { getContextData } from '@gameday/utils/selectors/getContextData';
import buildPlayerUrl from '@gameday/utils/buildPlayerUrl';
import { useSelector } from 'react-redux';

const BuildPlayerMatchup = ({ player, format, playerType, isLoading, language, deviceInteraction, eraLabel, PlayerTypes, tracking }) => {
    const name = player?.person?.boxscoreName;
    const stats = player?.seasonStats?.pitching;
    const id = player?.person?.id;

    const {
        wins,
        losses,
        saves,
        era
    } = stats || {};

    const preEraString = (playerType === PlayerTypes.S) ? `${saves}` : `${wins} - ${losses}`;
    const statsString = `${era} ${eraLabel}`;
    const statsComp = <>
        { preEraString }
        <span>|</span>
        { statsString }
    </>;

    const getPlayerContextData = useSelector(getContextData);
    const { headshotType, disablePlayerLinks, playerPageContext } = getPlayerContextData(id);
    const playerPage = buildPlayerUrl({ nameSlug: id, language, playerPageContext });

    const handlePlayerPage = (e) => {
        const text = e?.target.innerText;
        const playerId = e?.currentTarget?.dataset?.playerid;
        const url = e?.currentTarget?.dataset?.url;
        const cfg = {
            componentName: ['Final', 'Decision'],
            text,
            activity: 'Player Click',
            linkName: 'Decision Click'
        };
        tracking.track.track_click(cfg);

        if (deviceInteraction.playercard({ title: 'Player Card', url, pid: playerId })) {
            e.preventDefault();
        }
    };

    return (
        <PlayerMatchup
            playerId={ id }
            isLoading={ isLoading }
            type={ PlayerMatchupTypes.PITCHERPOSTGAME }
            decision={ playerType }
            useDecisionBox={ true }
            name={ name }
            playerStats={ statsComp }
            linkProps={!disablePlayerLinks && {
                url: playerPage,
                handlers: {
                    onClick: (e) => handlePlayerPage(e)
                },
                target: '_blank',
                dataAttr: {
                    'data-playerid': id,
                    'data-url': playerPage
                }
            }}
            headshotType={ headshotType }
            headshotZoomScale={ 1 }
            headshotRatio='1:1'
            { ...format }
        />
    );
};

BuildPlayerMatchup.propTypes = {
    player: PropTypes.object,
    format: PropTypes.object,
    playerType: PropTypes.string,
    isLoading: PropTypes.bool,
    language: PropTypes.string,
    deviceInteraction: PropTypes.object,
    eraLabel: PropTypes.string,
    PlayerTypes: PropTypes.object
};

export default BuildPlayerMatchup;
